import { MsgSenderRole } from '@/features/chat-messages/types';
import { IApiMessageDto } from '@/services/swagger/easourcing/models';

export interface Message {
  id: string;
  content: string;
  timestamp: number;
  userId: string;
}

export type MessageWithTime<T> = T & {
  showTime?: boolean;
};

/**
 * 计算消息时间显示标记
 * 规则：
 * 1. 每天第一条消息显示时间
 * 2. 每10条消息显示一次时间
 * 3. 每60分钟显示一次时间
 * @param {Message[]} messages - 消息数组（保持原始顺序）
 * @returns {MessageWithTime[]} 带时间显示标记的消息数组（保持原始顺序）
 */
export function calculateMessageTimestamps<T extends IApiMessageDto>(messages: T[]): MessageWithTime<T>[] {
  if (messages.length === 0) {
    return [];
  }

  const result: MessageWithTime<T>[] = [];
  let lastShowTime = 0;
  let messageCount = 0;
  let lastDate = '';

  // 遍历消息（保持原始顺序）
  for (const message of messages) {
    if (!(message.senderRole === MsgSenderRole.User)) {
      result.push({
        ...message,
        showTime: false,
      });
      continue;
    }
    const messageDate = new Date(message.createTime).toDateString();
    const shouldShowTime =
      // 每天第一条消息
      messageDate !== lastDate ||
      // 每10条消息
      messageCount % 10 === 0 ||
      // 每60分钟
      message.createTime - lastShowTime >= 60 * 60 * 1000;

    if (shouldShowTime) {
      lastShowTime = message.createTime;
      lastDate = messageDate;
      messageCount = 1;
    } else {
      messageCount++;
    }

    result.push({
      ...message,
      showTime: shouldShowTime,
    });
  }

  return result;
}
